export const hash = '549b5b92-193c-41c8-be65-651390bed4de';

// export const gateKey = '';
export const gateKey = 'ek_live_g5Df6bp6y5ptAKeOVOpBloZHmqY0sb';
export const recaptchaKey = '6Ld9r7cZAAAAABw5wijiLD5PhlWqLivIN9NqFKi_';
export const apiUrl = `https://api-global-v3.encontrodigital.com.br/${hash}`;
export const apiSocket = 'https://socket-2023.encontrodigital.com.br';



//export const apiSocket = 'http://localhost:8080';

//export const apiUrl = `http://localhost:8000/${hash}`;
export const websitePath = 'https://forumatacadista.com.br';
export const urlWebsite = 'https://forumatacadista.com.br';
export const supportNumber = `555195181533`;
export const home = 'Home';
export const haveTranslate = false;
export const defaultProjectHash = 'evento';
// export const urlWebsite = 'http://localhost:3000';
export const eventName = '1º Fórum Atacadista RS';
export const logo = '/assets/logo.png';
export const background = '/assets/Fundo.jpg';
export const authTitle = '1º Fórum Atacadista RS';
export const dadosOrganizacao = '';
export const social = {
    whatsapp: '5551980512392',
    instagram: 'sindiatacadistasrs',
    facebook: 'sindiatacadistas',
    linkedin: 'company/sindiatacadistas',
    youtube: '',
    spotify: '',
    twitter: '',
    website: 'https://sindiatacadistas.com.br'
};


export const defaultTheme = {
    defaultBackground: 'none',
    defaultColor: '#fff',
    logo: {
        minWidth: '450px',
    },
    menu: {
        background: 'none',
        backgroundSticky: '#120E44',
        backgroundMobile: 'none',
        color: '#fff',
        shadow: '0',
        logoColor: 'none',
    },
};

export const getToken = (): string | null => {
    const token = localStorage.getItem(`@${authTitle}:token`);
    return token;
};
